import { Component, OnInit, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, Subscription, take } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from "../../services/product.service";
import { Product } from "../../classes/product";
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  public products: Product[] = [];
  public search: boolean = false;
  public searchTerm: string = '';
  public userName: any;
  
  
  public languages = [{ 
    name: 'English',
    code: 'en'
  }, {
    name: 'French',
    code: 'fr'
  }];

  public currencies = [{
    name: 'Euro',
    currency: 'EUR',
    price: 0.90 // price of euro
  }, {
    name: 'Rupees',
    currency: 'INR',
    price: 70.93 // price of inr
  }, {
    name: 'Pound',
    currency: 'GBP',
    price: 0.78 // price of euro
  }, {
    name: 'Dollar',
    currency: 'USD',
    price: 1 // price of usd
  }]

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router,
    private translate: TranslateService,
    public productService: ProductService,
    private analytics: GoogleAnalyticsService) {

  // this.productService.cart$.subscribe(cart => {
  //   this.products = cart;
  //   // Aquí se actualizan imágenes y datos en tiempo real
  // });
  //   // this.productService.cartItems.subscribe(response => this.products = response);
  }

  ngOnInit(): void {
    this.cartSubscription = this.productService.cart$.subscribe(cart => {
      this.products = cart;
    });
    this.userName = JSON.parse(sessionStorage.getItem("user"))?.userName || 'invitado@GIGMAX.com';
  }

  ngOnDestroy(): void {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }

  searchToggle(){
    this.search = !this.search;
  }

  changeLanguage(code){
    if (isPlatformBrowser(this.platformId)) {
      this.translate.use(code)
    }
  }

  get getTotal(): Observable<number> {
    return this.productService.cartCantTotal();
  }


  get getCantTotal(): Observable<number> {
    return this.productService.cartCantTotal();
  }

  removeItem(product: any) {
    this.productService.removeCartItem(product);
    this.analytics.sendEvent('remove_from_cart', {
      idEvento: 5,
      currency: 'MXN',
      userName: this.userName,
      value: product.price,
      items: [
        {
          item_name: product.title,
          item_id: product.id,
          price: product.price,
          quantity: 1,
        },
      ],
    });
    if(this.router.url === '/shop/checkout') {
      location.reload();
    }  
  }

  changeCurrency(currency: any) {
    this.productService.Currency = currency
  }

  submit() {
    this.productService.emitirStringSearch(this.searchTerm);
    this.router.navigate(['/shop/collection/left/sidebar']);
    this.search = !this.search;
  }

  validateSearchTerm(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚ\s-]$/; // Permite letras (con acentos), números, espacios y guiones
    const key = event.key; // Obtiene la tecla presionada
  
    if (!regex.test(key)) {
      event.preventDefault(); // Bloquea la entrada del carácter inválido
    }
  }
  private cartSubscription: Subscription;

  
}
